const u = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const PHONE_DISPLAY = "+91 9854039091";
export const PHONE_TEL = "+919854039091";
export const PHONE2_DISPLAY = "+91 9854039094";
export const PHONE2_TEL = "+919854039094";
export const EMAIL = "bigbossdigitech@gmail.com";
export const EMAIL2 = "bdm@bigbossdigitech.com";
export const WHATSAPP_URL = "https://wa.me/+919854039091";

export const FORMSPREE_ENDPOINT = "https://formspree.io/f/mjybjzzo";

export const FALLBACK_COMMERCIAL_IMG = u("photo-1518770660439-4636190af475");
export const FALLBACK_RESIDENTIAL_IMG = u("photo-1600607687939-ce8a6c25118c");

export const GATEWAY_IMAGES = {
  commercial: u("photo-1486406146926-c627a92ad1ab", 1600),
  residential: u("photo-1512917774080-9991f1c4c750", 1600),
};

export const COMMERCIAL_SOLUTIONS = [
  {
    id: "cctv",
    title: "CCTV Surveillance",
    img: "/img/cctv.jpg",
    brands: ["Honeywell", "CP Plus"],
    points: [
      "24×7 recording with live view on your phone, from anywhere",
      "Crystal-clear IP cameras with night vision",
      "Deters theft and settles disputes with solid evidence",
      "Layouts designed so your property has no blind spots",
    ],
  },
  {
    id: "fire-alarm",
    title: "Fire Alarm Systems",
    img: u("photo-1523861751938-121b5323b48b", 900),
    brands: ["Honeywell", "Morley IAS"],
    points: [
      "Detects smoke or heat at the earliest possible moment",
      "Pinpoints the exact room or zone where danger starts",
      "Instant alerts for fast, orderly evacuation",
      "Meets fire-safety compliance for hospitals, hotels & institutions",
    ],
  },
  {
    id: "access-control",
    title: "Access Control Systems",
    img: "/img/access-control.jpg",
    brands: ["Hikvision", "Honeywell", "eSSL", "Smart Power"],
    points: [
      "Entry via smart cards, fingerprint or face recognition",
      "You control who enters which area, and at what time",
      "Every entry is logged automatically",
      "Lost cards disabled in seconds — no locks to change",
    ],
  },
  {
    id: "epabx",
    title: "EPABX",
    img: "/img/epabx.jpg",
    brands: ["Telesys", "Grandstream"],
    points: [
      "One private phone network for your entire office",
      "Free intercom, call transfers & conference calls",
      "Callers reach the right person quickly — sounds professional",
      "Sized for your team today, with room to grow",
    ],
  },
  {
    id: "video-conferencing",
    title: "Video Conferencing",
    img: "/img/vc.jpg",
    brands: ["Yealink", "Cisco"],
    points: [
      "Boardroom-quality HD video meetings with anyone, anywhere",
      "Cameras, mics & displays that feel face-to-face",
      "Cuts travel time and cost, speeds up decisions",
      "Meetings start at the touch of a single button",
    ],
  },
  {
    id: "audio-visual",
    title: "Audio Visual",
    img: u("photo-1478720568477-152d9b164e26", 900),
    brands: ["Bosch", "Bose", "JBL", "Epson", "Panasonic", "Samsung"],
    points: [
      "Projectors, LED walls & professional speakers",
      "Boardrooms, auditoriums, training centres & lobbies",
      "Centrally controlled — no technician needed",
      "Communication your audience actually remembers",
    ],
  },
  {
    id: "signage",
    title: "Signage Displays",
    img: "/img/signage.jpg",
    brands: ["Samsung", "Aero"],
    points: [
      "Bright, dynamic screens updated in seconds from one dashboard",
      "Directories, promotions, menus & announcements",
      "Content scheduled by time of day and location",
      "Premium look, zero printing costs",
    ],
  },
  {
    id: "pa-bgm",
    title: "PA & Background Music",
    img: "/img/pa.jpg",
    brands: ["Bose", "Bosch", "JBL"],
    points: [
      "Clear announcements and music across every corner",
      "Zone-wise paging without disturbing other areas",
      "Emergency evacuation broadcasts on the same system",
      "Speakers tuned to your space — rich, never harsh",
    ],
  },
  {
    id: "lan-wifi",
    title: "LAN & Wi-Fi",
    img: "/img/wifi-lan.jpg",
    brands: ["Cisco", "Netgear", "TP-Link"],
    points: [
      "Structured cabling — the nervous system of your building",
      "Enterprise Wi-Fi with zero dead zones",
      "Hundreds of users connected smoothly at once",
      "Built right the first time, serves for decades",
    ],
  },
  {
    id: "bms",
    title: "Building Management Systems",
    img: u("photo-1551288049-bebda4e38f71", 900),
    brands: ["Resonant"],
    points: [
      "One screen controls lighting, AC, power, water & safety",
      "Cuts energy waste automatically",
      "Alerts your team before faults become breakdowns",
      "Real-time visibility of the entire property",
    ],
  },
  {
    id: "online-ups",
    title: "Online UPS",
    img: "/img/ups.jpg",
    brands: ["Vertiv", "Delta"],
    points: [
      "Clean, uninterrupted power the instant mains fail",
      "Servers, CCTV & networks keep running without a flicker",
      "Protects electronics from surges and spikes",
      "Capacity & backup time sized exactly to your load",
    ],
  },
  {
    id: "motorized-gates",
    title: "Motorized Gates & Blinds",
    img: "/img/gate.jpg",
    brands: ["Smartpower", "Smartnode", "Matrix"],
    points: [
      "Gates open via remote, card tap or phone app",
      "Silent blinds manage glare, heat and privacy",
      "Schedules and sunlight sensors for hands-free comfort",
      "Integrates with your security & automation systems",
    ],
  },
  {
    id: "metal-detectors",
    title: "Metal Detectors & Digital Lockers",
    img: "/img/metal-detector.jpg",
    brands: ["ESSL", "Ozone", "Yale"],
    points: [
      "Screens every visitor at the entrance",
      "Digital lockers secure valuables with PIN or biometrics",
      "Fast guest throughput, full control for security teams",
      "Complete checkpoint supply, installation & maintenance",
    ],
  },
];

export const RESIDENTIAL_SOLUTIONS = [
  {
    id: "cctv",
    title: "CCTV Surveillance",
    img: "/img/cctv-res.jpg",
    brands: ["Honeywell", "CP Plus"],
    points: [
      "Live view of your home on your phone, from anywhere",
      "Discreet cameras at entry points & common areas",
      "Night-vision recordings as solid evidence",
      "The strongest deterrent against break-ins",
    ],
  },
  {
    id: "video-door-phone",
    title: "Video Door Phones",
    img: "/img/vdp.jpg",
    brands: ["Panasonic", "Hikvision", "Akuvox"],
    points: [
      "See & speak to visitors before opening the door",
      "Answer the door from anywhere on your phone",
      "Remote unlock only when you decide",
      "Visitor images captured automatically",
    ],
  },
  {
    id: "smart-locks",
    title: "Smart Locks",
    img: "/img/smart-lock.jpg",
    brands: ["Ozone", "Yale", "eSSL"],
    points: [
      "Unlock with fingerprint, PIN, card or smartphone",
      "Temporary access for guests, staff or tenants",
      "Every entry logged; the door can auto-lock",
      "No more duplicate keys floating around",
    ],
  },
  {
    id: "home-automation",
    title: "Home Automation",
    img: u("photo-1543512214-318c7553f230", 900),
    brands: ["Smart Node", "Matrix"],
    points: ["Lights & fans", "Curtains & blinds", "Air-conditioning", "Gate motors", "Geysers"],
    controls: "Everything controlled by app, voice command, scheduling and scenes.",
  },
  {
    id: "ip-pbx",
    title: "IP PBX",
    img: "/img/epabx.jpg",
    brands: ["Telesys", "Grandstream"],
    points: [
      "Free intercom between rooms, floors & the main gate",
      "Outside calls route over the internet to cut bills",
      "Ties in your video door phone and security system",
      "One small box organises all home communication",
    ],
  },
  {
    id: "home-theater",
    title: "Home Theater",
    img: "/img/home-theater-new.jpg",
    brands: ["Sonos", "Bowers & Wilkins", "Polk Audio", "Epson", "Focal"],
    points: [
      "Cinema-grade surround sound and giant-screen picture",
      "Acoustics, speakers, lighting & seating handled by us",
      "Films, sports and gaming become family events",
      "Everything runs from one simple remote or app",
    ],
  },
  {
    id: "multiroom-av",
    title: "Multi-room Audio Visual",
    img: u("photo-1545454675-3531b543be5d", 900),
    brands: ["Sonos"],
    points: [
      "Music follows you from room to room",
      "Same playlist everywhere, or different per room",
      "Speakers hidden in ceilings and walls",
      "Every room controlled from your phone",
    ],
  },
  {
    id: "lan-wifi",
    title: "Network LAN & Wi-Fi",
    img: "/img/wifi-lan.jpg",
    brands: ["Cisco", "TP-Link"],
    points: [
      "Strong Wi-Fi in every corner — even terraces & lawns",
      "No buffering for work, streaming or gaming",
      "One professional network replaces boosters & extenders",
      "The foundation every smart home runs on",
    ],
  },
  {
    id: "online-ups",
    title: "Online UPS",
    img: "/img/ups.jpg",
    brands: ["Vertiv", "Delta"],
    points: [
      "Wi-Fi, CCTV & computers stay on through power cuts",
      "No dropped calls or rebooted routers",
      "Silent, safe installation sized to your home",
      "Protection from voltage swings and surges",
    ],
  },
  {
    id: "intruder-alarms",
    title: "Intruder Alarms",
    img: "/img/intruder.jpg",
    brands: ["Abhedya Suraksha", "Texecom"],
    points: [
      "Smart sensors watch doors, windows and rooms",
      "Siren sounds and your phone alerts within seconds",
      "Deters most break-ins before they happen",
      "Arm or disarm the whole home with a single tap",
    ],
  },
];

export const BRAND_NOTE =
  "Looking for a specific brand? We can source and supply custom brands upon request, or provide expert suggestions tailored to your exact needs.";

export const USPS = [
  { icon: "Award", title: "24 Years of Legacy", text: "24 years of experience in the industry — and growing stronger.", img: u("photo-1477959858617-67f85cf4f1df", 900) },
  { icon: "Cpu", title: "Engineering Leadership", text: "Technical expertise of electronic engineering by the Business Head." },
  { icon: "PencilRuler", title: "AutoCAD Design Expertise", text: "Designing expertise of projects on AutoCAD drawings for hospitals, hotels, universities, offices, villas & more.", img: u("photo-1503387762-592deb58ef4e", 900) },
  { icon: "Building2", title: "15,000+ Projects Executed", text: "Residential, commercial & government projects executed across India." },
  { icon: "Headphones", title: "Dedicated Service Department", text: "A dedicated & structured customer service department for smooth & prompt services." },
  { icon: "IndianRupee", title: "Value for Money", text: "Client-need centric technical designing to make the solution value for money.", img: u("photo-1497366216548-37526070297c", 900) },
  { icon: "Layers", title: "15+ Solutions, One Roof", text: "15+ solutions of the same domain under one roof — easing multi-vendor meetings & clashes." },
  { icon: "Timer", title: "12–24 Hour Response", text: "A prompt format to attend after-sales service within 12 to 24 hours.", img: u("photo-1581094794329-c8112a89af12", 900) },
  { icon: "MapPin", title: "East & West India Presence", text: "Offices in Guwahati & Mumbai with pan-India project support for multi-location requirements." },
];

export const COMMERCIAL_PROJECTS = [
  { name: "Protech", icon: "Building2" },
  { name: "Uttarayan Ville", icon: "Building2" },
  { name: "Infinity", icon: "Building2" },
  { name: "NCS Square", icon: "Building2" },
  { name: "Exotica Greens", icon: "Building2" },
  { name: "IIT Guwahati", icon: "GraduationCap" },
  { name: "Delhi Public School Khanapara", icon: "BookOpen" },
  { name: "Cotton University", icon: "GraduationCap" },
  { name: "Pratiksha College", icon: "GraduationCap" },
  { name: "KK Handiqui State Open University", icon: "GraduationCap" },
  { name: "Reserve Bank of India", icon: "Landmark" },
  { name: "Ornate Hotel", icon: "BedDouble" },
  { name: "Novotel Hotel", icon: "BedDouble" },
  { name: "Janaki Farms", icon: "Sprout" },
  { name: "Pratiksha Hotel", icon: "BedDouble" },
  { name: "Guwahati Metro Hospital", icon: "HeartPulse" },
  { name: "Coras Hospital", icon: "HeartPulse" },
  { name: "Sri Sankardeva Nethralaya", icon: "Eye" },
  { name: "Assam Cancer Care Foundation", icon: "HeartPulse" },
  { name: "MGT Motors", icon: "Car" },
  { name: "Westside", icon: "ShoppingBag" },
  { name: "Home Developers Group", icon: "HardHat" },
  { name: "Nemichand Bamalwa Jewellers", icon: "Gem" },
];

export const RESIDENTIAL_PROJECTS = [
  { img: "/img/bungalow.jpg", title: "Bungalows", desc: "Standalone homes secured and automated end to end." },
  { img: "/img/villas.jpg", title: "Villas", desc: "Gated villa communities on one unified electronic backbone." },
  { img: "/img/apartments.jpg", title: "Apartments", desc: "High-rise flats with enterprise-grade connectivity." },
  { img: "/img/home-theater.jpg", title: "Home Theater", desc: "Cinema-grade rooms, designed and calibrated inside your home." },
];

export const LOCATIONS = [
  {
    id: "guwahati",
    city: "Guwahati",
    region: "Assam — Head Office",
    address: "2nd Floor, House No. 2, Chilarai Nagar Path, Bhangagarh, Assam 781005",
    img: "/img/kamakhya.jpg",
    alt: "Kamakhya Temple, Guwahati",
  },
  {
    id: "mumbai",
    city: "Mumbai",
    region: "Maharashtra — West India",
    address: "G-156, Moongipa Arcade, Commercial Entry no.2, DN Nagar Road, Andheri West, Mumbai - 400053",
    img: u("photo-1570168007204-dfb528c6958f", 1000),
    alt: "Gateway of India, Mumbai",
  },
];

export const DIVISIONS = {
  commercial: {
    key: "commercial",
    label: "Commercial",
    kicker: "Commercial Division",
    heroTitle: "Commercial Solutions & System Integration",
    heroLines: ["Commercial Solutions", "& System Integration"],
    heroTag:
      "Surveillance, safety, networking and automation — engineered for hospitals, hotels, universities, offices and industry.",
    heroImg: u("photo-1449157291145-7efd050a4d0e", 1800),
    heroAlt: "Modern corporate glass architecture",
    solutions: COMMERCIAL_SOLUTIONS,
    fallbackImg: FALLBACK_COMMERCIAL_IMG,
  },
  residential: {
    key: "residential",
    label: "Residential",
    kicker: "Residential Division",
    heroTitle: "A home that protects, listens and responds.",
    heroLines: ["A home that protects,", "listens and responds."],
    heroTag:
      "Security, entertainment and automation — crafted for flats, villas, bungalows and penthouses.",
    heroImg: u("photo-1613490493576-7fde63acd811", 1800),
    heroAlt: "Luxury smart home exterior at dusk",
    solutions: RESIDENTIAL_SOLUTIONS,
    fallbackImg: FALLBACK_RESIDENTIAL_IMG,
  },
};
